import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../../redux/actions';
import { selectTheme } from '../../redux/selectors';
import { StyledButton } from '../../components';
import { Wrapper } from './styled';
export const BottomBar = () => {
    const { key } = useSelector(selectTheme);
    const dispatch = useDispatch();
    const changeTheme = (theme) => {
        dispatch(setTheme(theme));
    };
    return (_jsxs(Wrapper, { children: [_jsx(StyledButton, { onClick: () => changeTheme('light'), "$active": key === 'light', children: "Light" }), _jsx(StyledButton, { onClick: () => changeTheme('dark'), "$active": key === 'dark', children: "Dark" }), _jsx(StyledButton, { onClick: () => changeTheme('green'), "$active": key === 'green', children: "Green" }), _jsx(StyledButton, { onClick: () => changeTheme('random'), "$active": key === 'random', children: "Exotic" })] }));
};
